import { Grid } from '@material-ui/core';
import { EnderecoForm } from 'app/main/pessoa/Endereco';
import React from 'react';

function EnderecoTab() {
  return (
    <Grid container spacing={3} className="mt-10">
      <EnderecoForm />
    </Grid>
  );
}

export default EnderecoTab;
